/**
 * Lifecycle status for a e-signature envelope
 */
export enum ESignatureEnvelopeStatusEnum {
	CREATED = 'created',
	SENT = 'sent',
	RECIPIENT_SIGNED = 'recipient-signed',
	SENDER_SIGNED = 'sender-signed',
	COMPLETED = 'completed',
	EXPIRED = 'expired',
	FAILED = 'failed',
}
